// Generated by CoffeeScript 2.4.1
(function() {
  var Weaver, WeaverObject;

  Weaver = require('./Weaver');

  WeaverObject = class WeaverObject {
    constructor(_id, _name) {
      this._id = _id;
      this._name = _name;
    }

    
    // Load all instances
    static list() {
      throw new Error('Please implement the list method');
    }

    // Load one specific instance
    static load(id) {
      throw new Error('Please implement the load method');
    }

    // Getters
    id() {
      return this._id;
    }

    name() {
      return this._name;
    }

    setName(name) {
      return this._name = name;
    }

    // Persist object to database
    save() {
      throw new Error('Please implement the save method');
    }

    // deprecated
    create() {
      return this.save();
    }

    // Remove object from database
    destroy() {
      throw new Error('Please implement the destroy method');
    }

    // deprecated
    delete() {
      return this.destroy();
    }

  };

  module.exports = WeaverObject;

}).call(this);
